module.exports = __webpack_public_path__ + "media/images/device2-f7c64ed1.png";